<template>
    <div class="mb-2">
        Natureza:
        <app-status :status="natureza.nome"></app-status>
        <br />Carga Horária:
        <strong>{{ natureza.cargaHoraria }}</strong>
        <br />Valor Hora:
        <strong>{{ natureza.valorHora | currency }}</strong>
        <br />Desp. Viagem:
        <strong>{{ natureza.valorDespViagem | currency }} </strong>
        <app-status status="CANCELADA" v-if="natureza.cancelada"></app-status>
        <contratacao-atualizar-desp-viagem
            :despViagem="natureza"
            :contratacoesServicos="contratacoesServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
        ></contratacao-atualizar-desp-viagem>
        <contratacao-cancelar-desp-viagem
            :despViagem="natureza"
            :contratacoesServicos="contratacoesServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
        >
        </contratacao-cancelar-desp-viagem>
        <contratacao-desfazer-cancelamento-desp-viagem
            :despViagem="natureza"
            :contratacoesServicos="contratacoesServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
        >
        </contratacao-desfazer-cancelamento-desp-viagem>
        <contratacao-reprogramar-desp-viagem
            :despViagem="natureza"
            :contratacoesServicos="contratacoesServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
        >
        </contratacao-reprogramar-desp-viagem>
        <span v-if="natureza.dataReprogramada">
            <br />Data Reprogramada:
            <strong>{{
                $moment(natureza.dataReprogramada).format('DD/MM/YYYY')
            }}</strong>
            <br />Justificativa da data reprogramada:
            <strong>{{ natureza.justificativaDataReprogramada }}</strong>
        </span>
        <span v-if="natureza.cancelada">
            <br />Justificativa do cancelamento:
            <strong>{{ natureza.justificativaCancelamento }}</strong>
        </span>
        <span v-if="natureza.valorDespViagemAjustado > 0">
            <br />Desp. Viagem Ajustada:
            <strong>{{ natureza.valorDespViagemAjustado | currency }} </strong>
            <btn-justificativa-desp-viagem
                :despViagem="natureza"
            ></btn-justificativa-desp-viagem>
        </span>
        <span v-if="natureza.valorDespViagem > 0">
            <br />Comprometimento:
            <app-status
                :status="natureza.status"
                v-if="
                    natureza.status != 'COMPROMETIDO' &&
                    natureza.status != 'ATUALIZAR COMPROMETIMENTO'
                "
            ></app-status>
            <desp-viagem-erro-comprometimento
                :natureza="natureza"
                :movimentosServicos="movimentosServicos"
            ></desp-viagem-erro-comprometimento>
            <span
                v-if="
                    natureza.status == 'COMPROMETIDO' ||
                    natureza.status == 'ATUALIZAR COMPROMETIMENTO'
                "
            >
                <strong>{{ natureza.idRm }}</strong>
                <status-fin :status="natureza.statusFin"></status-fin>
                <desp-viagem-excluir-comprometimento
                    :natureza="natureza"
                    :movimentosServicos="movimentosServicos"
                    @obterAtualizacao="$emit('obterAtualizacao')"
                ></desp-viagem-excluir-comprometimento>
            </span>
        </span>
        <br />Valor Total:
        <strong>{{ natureza.valorTotal | currency }}</strong>
        <span v-if="natureza.pagamento">
            <br />
            Protocolo de Pagamento: <strong>{{ natureza.pagamento }}</strong>
        </span>
    </div>
</template>

<script>
import DespViagemErroComprometimento from './../despviagens/DespViagemErroComprometimento'
import DespViagemExcluirComprometimento from './../despviagens/DespViagemExcluirComprometimento'
import ContratacaoAtualizarDespViagem from './ContratacaoAtualizarDespViagem'
import ContratacaoCancelarDespViagem from './ContratacaoCancelarDespViagem'
import ContratacaoDesfazerCancelamentoDespViagem from './ContratacaoDesfazerCancelamentoDespViagem'
import BtnJustificativaDespViagem from './BtnJustificativaDespViagem'
import StatusFin from './../StatusFinIdRm'
import ContratacaoReprogramarDespViagem from './ContratacaoReprogramarDespViagem'

export default {
    components: {
        DespViagemErroComprometimento,
        DespViagemExcluirComprometimento,
        ContratacaoAtualizarDespViagem,
        ContratacaoCancelarDespViagem,
        BtnJustificativaDespViagem,
        StatusFin,
        ContratacaoDesfazerCancelamentoDespViagem,
        ContratacaoReprogramarDespViagem
    },

    props: {
        natureza: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    }
}
</script>
